const applet = '/p/teste/senha';

const view = `${applet}/redefinir/:cid`;

const urls = {
  get: {
    validateCid: '/v1/pub/validar_solicitacao_email/:cid',
  },
  post: {
    resetPassword: '/v1/pub/redefinir_password/:cid',
  },
};

export { applet, view, urls };
